// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__3-vPC","content":"profile_content__lRJek","title":"profile_title__T1wPZ"};